module.exports = __webpack_public_path__ + "public/SiteImages/adminLoginPage.svg?e6615a99";